import LocalStorage from '../data/local-storage';
import AuthService from './auth-service';
import { escapeHtml } from '../utils/helpers';

class BookmarkService {
  constructor() {
    this.bookmarks = [];
  }

  load() {
    this.bookmarks = this.getBookmarks();
  }

  getKey() {
    return LocalStorage.getUserSpecificKey('heliaedu_user_bookmarks', AuthService.user.id);
  }

  getBookmarks() {
    return LocalStorage.getObject(this.getKey()) || [];
  }

  setBookmarks(bookmarks) {
    LocalStorage.setObject(this.getKey(), bookmarks);
    this.bookmarks = bookmarks;
  }

  updateBubble() {
    const container = document.querySelector('#bookmark-content');
    if (!container) return;
    const bookmarks = this.getBookmarks();
    container.innerHTML = '';
    if (bookmarks.length === 0) {
      container.innerHTML = `<div class="bookmark-null"><span class="material-symbols-rounded" aria-hidden="true">bookmarks</span><p>Anda belum menyimpan apapun</p></div>`;
    } else {
      const recent = bookmarks.sort((a,b) => new Date(b.savedAt)-new Date(a.savedAt)).slice(0,5);
      let html = '';
      recent.forEach(b => {
        html += `<a href="#/post/${b.storyId}" class="bookmark-preview"><div class="bookmark-sender"><div class="bookmark-photo"><img src="${b.userPhoto}" alt="${b.userName}" width="32" height="32" loading="lazy"></div><div class="bookmark-name"><strong>${b.userName}</strong></div></div><div class="preview-bookmark"><p>${escapeHtml(b.description).substring(0,60)}${b.description.length>60?'...':''}</p></div></a>`;
      });
      container.innerHTML = html;
    }
  }
}

export default new BookmarkService();
